import {Component, ElementRef, EventEmitter, OnInit, Output, QueryList, ViewChildren} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {AppService} from '../../services/app.service';
import {ProductFilter} from '../../_models/product-filter';
import {ProductService} from '../../services/product.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-listing-filters',
  templateUrl: './listing-filters.component.html',
  styleUrls: ['./listing-filters.component.css']
})
export class ListingFiltersComponent implements OnInit {
  responseReceived = false;
  locations: any[];
  locationsMaster: any[];
  priceRange = [];
  expandMobileFilter = false;
  expandMobileSortByFilter = false;
  expandDesktopLocationFilter: boolean = false;
  expandDesktopSortByFilter = false;
  expandDesktopPriceFilter = false;
  showOverlay = false;
  //{id: 'featured', label: 'Feature'},
  sortBy = [
    {id: 'title', label: 'A -Z alphabetically'},
    {id: 'recent', label: 'Newly'},
    {id: 'costliest', label: 'Price high to low'},
    {id: 'cheapest', label: 'Price low to high'}
  ];
  filter: ProductFilter = new ProductFilter();
  @Output() onFilterChange = new EventEmitter<ProductFilter>();

  constructor(
    private http: HttpClient,
    public appService: AppService,
    public productService: ProductService
  ) {
    this.closeFilterMenu();
  }

  ngOnInit(): void {
    var _location = this.appService.getCurrentCity();
    this.filter.city = _location;
    this.productService.loadStandardFilter(_location).subscribe(data => {
      const price_rangewithSelected = data.price_range.map((item) => {
        return {...item, isSelected: false};
      });
      const subLocalitywithSelected = data.sub_locality.map((item) => {
        return {...item, isSelected: false};
      });
      this.priceRange = price_rangewithSelected;
      this.locations = this.locationsMaster = subLocalitywithSelected;
    });
  }

  onLocationSelect($event): void {
    if ($event.target.checked) {
      this.filter.locality.push($event.target.value);
    } else {
      this.filter.locality = this.filter.locality.filter(x => x != $event.target.value);
    }
  }

  onSortBySelect($event): void {
    if ($event.target.checked) {
      this.filter.soryBy = $event.target.value;
      this.applyFilter();
    } else {
      this.filter.soryBy = '';
    }
  }

  onPriceSelect($event): void {
    if ($event.target.checked) {
      this.filter.priceRange.push($event.target.value);
    } else {
      this.filter.priceRange = this.filter.priceRange.filter(x => x != $event.target.value);
    }
  }

  searchLocation($event): void {
    if ($event.target.value == '') {
      this.locations = this.locationsMaster;
    } else {
      this.locations = this.locationsMaster.filter(x => {
        return x.sub_locality.toLowerCase().indexOf($event.target.value.toLowerCase()) != -1;
      });
    }
  }

  applyFilter(): void {
    this.closeFilterMenu();
    this.onFilterChange.emit(this.filter);
  }

  clearFilter($type = 'all'): void {
    this.closeFilterMenu();
    if ($type == 'location' || $type == 'all') {
      for (var i = 0; i < this.locations.length; i++) {
        this.locations[i].isSelected = false;
      }
      this.filter.locality = [];
    }
    if ($type == 'price_range' || $type == 'all') {
      for (var i = 0; i < this.priceRange.length; i++) {
        this.priceRange[i].isSelected = false;
      }
      this.filter.priceRange = [];
    }
    this.onFilterChange.emit(this.filter);
  }

  expandMenu($type, e = ''): void {
    this.closeFilterMenu();
    if ($type == 'filter') {
      this.expandMobileFilter = true;
    }
    if ($type == 'sort') {
      this.expandMobileSortByFilter = true;
    }
    if ($type === 'd_location' || $type === 'd_price' || $type === 'd_sort') {
      this.showOverlay = true;
    } else {
      this.showOverlay = false;
    }

    if ($type === 'd_location') {
      this.expandDesktopLocationFilter = true;
      setTimeout(f => {
        $('.select-location').find('.filter-dropdown-body').addClass('uk-open uk-dropdown-bottom-left');
      }, 50);
    }
    if ($type === 'd_price') {
      this.expandDesktopPriceFilter = true;
      setTimeout(f => {
        $('.select-price').find('.filter-dropdown-body').addClass('uk-open uk-dropdown-bottom-left');
      }, 50);
    }
    if ($type === 'd_sort') {
      this.expandDesktopSortByFilter = true;
      setTimeout(f => {
        $('.select-sort').find('.filter-dropdown-body').addClass('uk-open uk-dropdown-bottom-left');
      }, 50);
    }
  }

  closeFilterMenu(): void {
    this.showOverlay = false;
    this.expandMobileSortByFilter = false;
    this.expandMobileFilter = false;
    this.expandDesktopLocationFilter = false;
    this.expandDesktopPriceFilter = false;
    this.expandDesktopSortByFilter = false;
  }

}
